import React, { useRef, useState } from 'react';

import './SharedFileList.scss';
import icons from '../../shared/assets/icons';

import BackButton from '../BackButton/BackButton.jsx';

const { Upload, Download } = icons;

export default function SharedFileList(props) {
  const uploadButton = useRef(null);
  const [status, setStatus] = useState(null);

  return (
    <section className="sharedFileList">
      <BackButton />

      <div className="sharedFileList_title">
        <h3>Gedeelde documenten</h3>

        <form
          onSubmit={(e) => e.preventDefault()}
          className="sharedFileList_button"
        >
          <input
            hidden
            type="file"
            ref={uploadButton}
            onChange={(e) => uploadFile(e)}
          />

          <button
            className="sharedFileList_upload_button"
            onClick={() => uploadButton.current.click()}
          >
            <Upload />
            Uploaden
          </button>
        </form>
      </div>

      <div>{status}</div>

      <ul className="sharedFileList_table">
        <li className="sharedFileList_table_header">
          <div>Naam</div>
          <div>Datum</div>
          <div>Actie</div>
        </li>

        {!!props.list.length &&
          props.list.map((item, idx) => {
            const date = new Date(`${item.createdAt}`);

            return (
              <li key={idx} data-key={item.key}>
                <div
                  onClick={(e) => downloadFile(e)}
                  className="sharedFileList_file_name"
                >
                  {item.key}
                </div>

                <div>{date.toLocaleDateString().replace(/\//g, '-')}</div>

                <div>
                  <div
                    onClick={(e) => downloadFile(e)}
                    className="sharedFileList_button"
                  >
                    <button className="sharedFileList_download_button">
                      <Download />
                      Downloaden
                    </button>

                    <span className="sharedFileList_icon">
                      <Download />
                    </span>
                  </div>
                </div>
              </li>
            );
          })}
      </ul>
    </section>
  );

  function uploadFile(e) {
    setStatus('Uploading...');

    const reader = new FileReader();

    const file = e.target.files[0];

    if (!file) return setStatus('Uploading error');

    reader.readAsDataURL(file);

    reader.onload = () => {
      const content = reader.result.split(',')[1];

      props
        .uploadFileSpaceFile({
          variables: {
            fileKey: file.name,
            content,
            organizationName: props.provider?.accountName
          },
          skip: !content
        })
        .then(
          () => setStatus(null),
          () => setStatus('Uploading error')
        );
    };

    reader.onerror = () => setStatus('Uploading error');
  }

  function downloadFile(e) {
    const { key } = e.target.closest('li').dataset;

    props
      .downloadFileSpaceFile({
        variables: {
          fileKey: key,
          organizationName: props.provider?.accountName
        }
      })
      .then(
        (res) => {
          let a = document.createElement('a');

          a.href = `data:application/octet-stream;base64,
        ${res.data.downloadFileSpaceFile}`;
          a.download = key;

          a.click();

          a = null;
        },
        () => setStatus('Uploading error')
      );
  }
}
